import { FileUploadStatus } from '../enums';
export function singleFileUploadStartReducer(state, action) {
    return Object.assign(Object.assign({}, state), { byId: Object.assign(Object.assign({}, state.byId), { [action.payload.id]: Object.assign(Object.assign({}, state.byId[action.payload.id]), { uploadStatus: FileUploadStatus.IN_PROGRESS }) }) });
}
//# sourceMappingURL=singleFileUploadStartReducer.js.map